module.exports = __webpack_public_path__ + "img/fbstart.7a0b3ee2.jpg";